const dev = {
  baseUrl: 'http://localhost/hrm',
  // baseUrl: 'https://hub.llq.vn/hrm',
  api: {
    HOST: 'http://localhost:8081',
    // HOST: 'http://10.1.13.225:8888',
    // HOST: 'https://hub.llq.vn',
     VERSION: '/hrm/api/'
//    VERSION: '/api/'
  },
  auth: {
    // GRANT_TYPE: 'password',
    // CLIENT_ID: 'client1',
    // CLIENT_SECRET: 'secret'
  }
};

const prod = {
  baseUrl: 'https://hrm.llq.vn/',
  api: {
    HOST: 'https://hrm.llq.vn',
    VERSION: '/hrm/api/'
  },
  auth: {
    GRANT_TYPE: 'password',
    CLIENT_ID: 'client_id',
    CLIENT_SECRET: 'client_secret'
  }
};

// const config = process.env.REACT_APP_STAGE === 'production' ? prod : dev; // for test
const config = process.env.REACT_APP_STAGE === 'production' ? dev : prod; // for deploy

export default {
  // Add common config values here
  MAX_ATTACHMENT_SIZE: 5000000,
  ...config
};
